export function disable(route, brand) {
  if (route.data.disableConsultant != undefined) {
    return route.data.disableConsultant;
  }
}
